/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_ATTENDANCES_BEGIN,
  LIST_ATTENDANCES_SUCCESS,
  LIST_ATTENDANCES_ERR,

  CREATE_ATTENDANCE_BEGIN,
  CREATE_ATTENDANCE_SUCCESS,
  CREATE_ATTENDANCE_ERR,

  UPDATE_ATTENDANCE_BEGIN,
  UPDATE_ATTENDANCE_SUCCESS,
  UPDATE_ATTENDANCE_ERR,

  DELETE_ATTENDANCE_BEGIN,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_ERR,

  GET_ATTENDANCE_DETAILS_BEGIN,
  GET_ATTENDANCE_DETAILS_SUCCESS,
  GET_ATTENDANCE_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateAttendance: false,
  errorCreateAttendance: "",
  loadingUpdateAttendance: false,
  errorUpdateAttendance: "",
  attendances: [],
  loadingListAttendances: false,
  errorListAttendances: "",
  totalAttendances: 0,
  totalAttendancesPages: 0,
  loadingDeleteAttendance: false,
  errorDeleteAttendance: "",
  loadingGetAttendanceDetails: false,
  errorGetAttendanceDetails: null,
  attendanceDetails: {},
};

const attendancesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_ATTENDANCE_BEGIN:
      return {
        ...state,
        loadingCreateAttendance: true,
        errorCreateAttendance: "",
      };
    case CREATE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        attendances: [...state.attendances, data],
        loadingCreateAttendance: false,
        errorCreateAttendance: "",
      };
    case CREATE_ATTENDANCE_ERR:
      return {
        ...state,
        errorCreateAttendance: err,
        loadingCreateAttendance: false,
      };

    case LIST_ATTENDANCES_BEGIN:
      return {
        ...state,
        loadingListAttendances: true,
        errorListAttendances: false,
        totalAttendances: 0,
        totalAttendancesPages: 0,
      };
    case LIST_ATTENDANCES_SUCCESS:
      return {
        ...state,
        attendances: [...data.results],
        loadingListAttendances: false,
        errorListAttendances: null,
        totalAttendances: data.total_count,
        totalAttendancesPages: data.total_pages,
      };
    case LIST_ATTENDANCES_ERR:
      return {
        ...state,
        errorListAttendances: err,
        loadingListAttendances: false,
        totalAttendances: 0,
        totalAttendancesPages: 0,
      };

    case UPDATE_ATTENDANCE_BEGIN:
      return {
        ...state,
        loadingUpdateAttendance: true,
        errorUpdateAttendance: false,
      };
    case UPDATE_ATTENDANCE_SUCCESS:
      const updatedAttendances = state.attendances.map((attendance) =>
        attendance.id === data.id ? { ...attendance, ...data } : attendance
      );
      return {
        ...state,
        attendances: updatedAttendances,
        loadingUpdateAttendance: false,
        errorUpdateAttendance: null,
      };
    case UPDATE_ATTENDANCE_ERR:
      return {
        ...state,
        errorUpdateAttendance: err,
        loadingUpdateAttendance: false,
      };

    case DELETE_ATTENDANCE_BEGIN:
      return {
        ...state,
        loadingDeleteAttendance: true,
        errorDeleteAttendance: null,
      };
    case DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        attendances: state.attendances.filter(
          (attendance) => attendance.id !== data.id
        ),
        loadingDeleteAttendance: false,
        errorDeleteAttendance: null,
      };
    case DELETE_ATTENDANCE_ERR:
      return {
        ...state,
        errorDeleteAttendance: err,
        loadingDeleteAttendance: false,
      };

    case GET_ATTENDANCE_DETAILS_BEGIN:
      return {
        ...state,
        attendanceDetails: {},
        loadingGetAttendanceDetails: true,
        errorGetAttendanceDetails: null,
      };
    case GET_ATTENDANCE_DETAILS_SUCCESS:
      return {
        ...state,
        attendanceDetails: data,
        loadingGetAttendanceDetails: false,
        errorGetAttendanceDetails: null,
      };
    case GET_ATTENDANCE_DETAILS_ERR:
      return {
        ...state,
        attendanceDetails: {},
        loadingGetAttendanceDetails: false,
        errorGetAttendanceDetails: err,
      };

    default:
      return state;
  }
};

export { attendancesReducer };
